import React, { useState } from "react";
import { Control, Controller } from "react-hook-form";

import { NamedCounter } from "components/NamedCounter/NamedCounter";
import { AccordionParent } from "components/AccordionParent/AccordionParent";
import { Accordion } from "components/Accordion/Accordion";

import { ClientGroupForm } from "../ClientGroupInfo";

type Props = {
  control: Control<ClientGroupForm>;
};

const FIELDS = [
  {
    title: "Начальный % бонуса",
    varName: "startbonus",
    symbol: "%",
    titleWidth: 140,
  },
  {
    title: "Шаг бонуса",
    varName: "shiftbonus",
    symbol: "",
    titleWidth: 130,
  },
  {
    title: "Период увеличения бонуса",
    varName: "shiftbonussum",
    symbol: "",
    titleWidth: 200,
  },
  {
    title: "Текущий % бонуса",
    varName: "bonuspercent",
    symbol: "%",
    titleWidth: 140,
  },
  {
    title: "Конечный % бонуса",
    varName: "endbonus",
    symbol: "%",
    titleWidth: 130,
  },
  {
    title: "Следующее увеличение бонуса",
    varName: "nextbonussum",
    symbol: "",
    titleWidth: 200,
  },

  {
    title: "Начальная величина бонуса",
    varName: "startbonussum",
    symbol: "",
    titleWidth: 200,
  },
  {
    title: "Процент оплаты бонусами",
    varName: "maxbonuspay",
    symbol: "",
    titleWidth: 200,
  },
];

export const Bonuses = ({ control }: Props): JSX.Element => {
  const [bonusesCollapse, setBonusesCollapse] = useState(false);

  return (
    <Accordion
      withIcon={false}
      handleCollapse={() => setBonusesCollapse((prevState) => !prevState)}
      collapsed={!bonusesCollapse}
      iconClassNames="mr-3.5"
      parent={
        <AccordionParent
          name="Бонусы"
          collapsed={!bonusesCollapse}
          iconClassNames="mr-3.5"
        />
      }
    >
      <div className={"ml-3 mt-3"}>
        <div className="flex flex-wrap mt-2 gap-x-8 gap-y-4 justify-center">
          {FIELDS.map((currentField) => (
            <div key={currentField.title} className="flex ml-5 items-center">
              <Controller
                name={currentField.varName as keyof ClientGroupForm}
                control={control}
                render={({ field }) => (
                  <NamedCounter
                    {...field}
                    title={currentField.title}
                    value={field.value as string}
                    symbol={currentField.symbol}
                    titleWidth={currentField.titleWidth}
                  />
                )}
              />
            </div>
          ))}
        </div>
      </div>
    </Accordion>
  );
};
